const tagValues = {
  best_seller: {
    label: "BEST SELLER",
  },
  new: {
    label: "NEW LAUNCH",
  },
};

const ProductTag = ({ data, customClasses }) => {
  if (!data || !Object.keys(data).length) return null;

  let currentTag = null;
  if (data["best_seller"]) {
    currentTag = tagValues["best_seller"];
  } else if (data["new"]) {
    currentTag = tagValues["new"];
  }

  if (!currentTag) return null;
  return (
    <div 
        className={`
          px-[4px] md:px-3  py-[1px] sm:py-[0.2rem] 
          select-none text-[9px] bg-[#45d4d5]
          ${customClasses}
        `}
        style={{ 
          boxShadow: "#57aaba -2px 2px"
        }}
    >
      <span className="text-black font-bold	">
        {currentTag.label}
      </span>
    </div>
  );
};

export default ProductTag;
